module.exports = {"429006001":"竟陵街道","429006002":"候口街道","429006003":"杨林街道","429006100":"多宝镇","429006101":"拖市镇","429006102":"张港镇","429006103":"蒋场镇","429006104":"汪场镇","429006105":"渔薪镇","429006106":"黄潭镇","429006107":"岳口镇","429006108":"横林镇","429006109":"彭市镇","429006110":"麻洋镇","429006111":"多祥镇","429006112":"干驿镇","429006113":"马湾镇","429006114":"卢市镇","429006115":"小板镇","429006116":"九真镇","429006118":"皂市镇","429006119":"胡市镇","429006120":"石家河镇","429006121":"佛子山镇","429006201":"净潭乡","429006450":"蒋湖农场","429006451":"白茅湖农场","429006452":"沉湖管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/429006.json
// module id = 1926
// module chunks = 0